import { useCallback } from "react"
import { setProductIdentifiers } from "reducers/products/products-actions"
import { useAppDispatch } from "reducers/store"

export const useProductIdentifiers = () => {
  const appDispatch = useAppDispatch()

  const identifiersCleanup = useCallback(() => {
    appDispatch(
      setProductIdentifiers({
        productId: "",
        productPrefixUrl: ""
      })
    )
  }, [])

  const identifiersDefinition = useCallback((productId: string, productPrefixUrl = "") => {
    appDispatch(
      setProductIdentifiers({
        productId,
        productPrefixUrl
      })
    )
  }, [])

  return {
    identifiersCleanup,
    identifiersDefinition
  }
}
